import { Component, computed, input, signal } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-setup-summary',
  imports: [NzCardModule, NzButtonModule, NzIconModule],
  templateUrl: './setup-summary.component.html',
  styleUrl: './setup-summary.component.scss',
})
export class SetupSummaryComponent {
  // Controls whether the collapse/expand button is shown
  readonly showToggle = input<boolean>(false);

  // Custom subtitle shown to the right of the "Setup summary" title when collapsed
  readonly collapsedTitle = input<string>('');

  // Local collapsed state (collapsed by default)
  readonly collapsed = signal(true);

  readonly toggleLabel = computed(() =>
    this.collapsed() ? 'expand' : 'collapse',
  );
  readonly toggleIcon = computed(() => (this.collapsed() ? 'down' : 'up'));

  toggle() {
    this.collapsed.update((v) => !v);
  }
}
